import type { Goal } from "instantdb/types";

export const WEIGHT_GOALS: Partial<Goal>[] = [
  {
    id: "healthy-weight-maintenance",
    title: "Healthy weight maintenance",
    description: "Maintain weight within a healthy range",
    symbol: "⚖️",
  },
  {
    id: "gradual-weight-loss",
    title: "Gradual weight loss",
    description: "Lose weight at a healthy and sustainable pace",
    symbol: "📉",
  },
  {
    id: "body-composition",
    title: "Body composition",
    description: "Focus on improving muscle-to-fat ratio rather than just weight",
    symbol: "💪",
  },
];
